import styled from 'styled-components';
import { addGridContainerStyles } from "./utils/gridContainerStyles";
var Grid = styled.div.withConfig({
  displayName: "Grid",
  componentId: "sc-1p88k8z-0"
})(["display:grid;", ""], addGridContainerStyles);
export default Grid;